import React from 'react';
import _ from 'lodash';
import { withRouter } from 'Components/withRouter';
import styles from './BookingReferenceEditForm.module.css';

class BookingReferenceEditForm extends React.Component {
    constructor(props) {
        super(props);

        var initialState = {
            isNew: props.isNew,
            id: '',
            account: '',
            reference: '',
            markup: ''
        };

        if (props.edit_reference != null && props.edit_reference != undefined) {
            Object.assign(initialState, {
                id: props.edit_reference.id,
                account: props.edit_reference.account,
                reference: props.edit_reference.reference,
                markup: props.edit_reference.markup
            });
        }
        
        this.state = initialState;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        })
    }

    handleSubmit(event) {
        event.preventDefault();

        const formData = new FormData(document.getElementById('bookingReferenceEditForm'));
        this.props.onFormSubmit(formData);
    }

    handleCancel(event) {
        this.props.router.navigate(-1);
    }

    render() {

        var accountField = null;

        if(this.state.isNew === true) {

            var accountOptions = null;

            if (this.props.accountOptions !== undefined && this.props.accountOptions !== null) {
                var sortedAccounts = _.sortBy(this.props.accountOptions, ['label']);
                accountOptions = sortedAccounts.map(
                    (a) => <option key={a.value} value={a.value}>{a.label}</option>
                    );
            }

            accountField = (
                <div className="form-group form-group-sm">
                    <label>*Account</label>
                    <select className="form-control" name="account" value={this.state.account} onChange={this.handleChange}>
                        {accountOptions}
                    </select>
                </div>
            );
        } else {
            accountField = (<input type="hidden" name="account" value={this.state.account} onChange={this.handleChange} />)
        }

        return (
            <form id="bookingReferenceEditForm" styleName="form" onSubmit={this.handleSubmit}>
                <input id="inputBookingReferenceId" name="id" type="hidden" value={this.state.id} />
                <div className="row">
                    <div className="col-sm-offset-4 col-sm-4">
                        {accountField}
                        <div className="form-group form-group-sm">
                            <label>Reference</label>
                            <input type="text" className="form-control" name="reference" value={this.state.reference} onChange={this.handleChange} />
                        </div>
                        <div className="form-group form-group-sm">
                            <label>Markup</label>
                            <input type="text" className="form-control" name="markup" value={this.state.markup} onChange={this.handleChange} />
                        </div>
                        <button type="submit" className="btn btn-default btn-dl-green">SAVE</button>
                        <button type="button" className="btn btn-default btn-dl-green" onClick={this.handleCancel}>CANCEL</button>
                    </div>
                </div>
            </form>
            )
    }
}

export default withRouter(BookingReferenceEditForm);